export default __webpack_public_path__ + "static/media/onboarding-2.8566fc93.jpg";